import React, { useState } from 'react';
import styles from './style.module.css';
import { auth } from '../../../firebase';
import { Link } from 'react-router-dom';

export default function Header() {
  const [path, setPath] = useState(window.location.pathname);
  function signOut() {
    auth.signOut();
  }

  const NavBtn = ({ title, href, isActive = false }) => {
    return (
      <Link
        style={{
          marginRight: 10,
          fontSize: 12
        }}
        onClick={() => {
          setPath(href);
        }}
        className={['btn ' + (isActive ? 'btn-dark' : 'btn-light')]}
        to={href}>
        {title}
      </Link>
    );
  };

  return (
    <header className={styles.container}>
      <div className="container">
        {/* <NavBtn
          title={'Refunds'}
          href={'/refunds'}
          isActive={path === '/refunds' || path === '/'}
        /> */}
        <NavBtn
          title={'Search'}
          href={'/search'}
          isActive={path === '/search'}
        />
        <NavBtn
          title={'Payments'}
          href={'/pay'}
          isActive={path === '/pay'}
        />
        <NavBtn
          title={'Submissions'}
          href={'/submissions'}
          isActive={path === '/submissions'}
        />
        <NavBtn
          title={'Deliveries'}
          href={'/deliveries'}
          isActive={path === '/deliveries'}
        />
        <NavBtn
          title={'Archived deliveries'}
          href={'/arch-deliveries'}
          isActive={path === '/arch-deliveries'}
        />
        <button
          style={{
            marginRight: 10,
            fontSize: 12
          }}
          className="btn btn-danger"
          onClick={signOut}>
          Log Out
        </button>
      </div>
    </header>
  );
}
